let sse = null;
const baseURL = sessionStorage.getItem('baseURL')

export const startSSE = (dispatch) => {
  if (sse) return; // prevent duplicates

  sse = new EventSource(baseURL+"notifications/events");

  sse.onmessage = (e) => {
    try {
      dispatch(JSON.parse(e.data));
    } catch (err) {
      console.error("Invalid SSE payload", err);
    }
  };

  sse.onerror = (err) => {
    console.error("SSE error", err);
  };
};

export const stopSSE = () => {
  if (sse) {
    sse.close();
    sse = null;
  }
};
